import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import Time from "../components/time";
import VacationItem from "../components/vacation-item";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

export default function HoursAndDaysWhole({
  onSelectedDateFrom,
  dateFrom,
  checked,
  onChecked,
  is24HoursFormat,
  timeTo,
  onSelectTimeTo,
  timeFrom,
  onSelectTimeFrom,
  dateTo,
}) {
  return (
    <>
      <div
        className="check-in-out-container"
        id="hours-and-days-whole-from-container"
      >
        <CalendarPicker
          label={"From"}
          isStanAlone={false}
          onSelected={(value, str) => onSelectedDateFrom(value, str)}
          value={dateFrom}
          id="hours-and-days-whole-calendar-from-component"
        />
        {!checked && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeFrom}
            onChange={(value) => onSelectTimeFrom?.(value)}
            id="hours-and-days-whole-time-from-component"
          />
        )}
      </div>
      <div
        className="check-in-out-container"
        id="hours-and-days-whole-to-container"
      >
        <CalendarPicker
          label={"To"}
          isStanAlone={false}
          isDisabled
          value={dateTo}
          id="hours-and-days-whole-calendar-to-component"
        />
        {!checked && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeTo}
            onChange={(value) => onSelectTimeTo?.(value)}
            id="hours-and-days-whole-time-to-component"
          />
        )}
      </div>
      <VacationItem
        title={"Whole day"}
        checked={checked}
        onChecked={onChecked}
        icon={HourglassBottomIcon}
        color={"orange"}
        id="hours-and-days-whole-half-day-component"
      />
    </>
  );
}
